import { client } from "api";
import { Company, OnboardingState } from "models/Company";

export type UpdateOboardingStatusRequest = {
  id: Company["id"];
  onboardingState: OnboardingState;
}

export type UpdateOboardingStatusResponse = Company;

export const updateOboardingStatus = ({ id, ...request }: UpdateOboardingStatusRequest) =>
  client.post<UpdateOboardingStatusResponse>(`/company/${id}/onboarding`, request).then((res) => res.data);
